module.exports = __webpack_public_path__ + "static/img/image_battery.67f94415.svg";